import {initialState as authState, reducer as authReducer} from './auth';
import {initialState as appState, reducer as appReducer} from './appContext';
import {initialState as jobState, reducer as jobReducer} from './job/jobfeed';
import {
  initialState as jobDetailState,
  reducer as jobDetailReducer,
} from './job/jobdetail';
import {initialState as userState, reducer as userReducer} from './user';
import {
  initialState as adsState,
  reducer as adsReducer,
  selectAdsState,
} from './ads';
import {
  initialState as competitionState,
  reducer as competitionReducer,
} from './competition';
import {
  initialState as botDetectionState,
  reducer as botDetectionReducer,
  selectBotDetection,
  showCaptcha,
  hideCaptcha,
} from './botDetection';

export {
  authState,
  appState,
  jobState,
  jobDetailState,
  userState,
  adsState,
  competitionState,
  botDetectionState,
};

export {selectAdsState, selectBotDetection};

export {showCaptcha, hideCaptcha};

export {
  authReducer,
  appReducer,
  jobReducer,
  jobDetailReducer,
  userReducer,
  adsReducer,
  competitionReducer,
  botDetectionReducer,
};
